import { useState } from 'react';
import { Button, Container } from "reactstrap";
import { pdfjs, Document, Page } from 'react-pdf';
import { BarLoader } from 'react-spinners';

const soutMoscowPDF = require('../../assets/pdf/TopRange_SOUT_Moscow.pdf');
const soutSpbPDF = require('../../assets/pdf/TopRange_SOUT_Spb.pdf');
const soutLakhtaPDF = require('../../assets/pdf/TopRange_SOUT_Lakhta.pdf');
const sout2026PDF = require('../../assets/pdf/TopRange_SOUT_2026.pdf');
const registerPDF = require('../../assets/pdf/TopRange_Safety_documents_register.pdf');


const SafetyPDF = ({title, subtitle, pdfDocument}) => {

  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const nextPage = () => setPageNumber(pageNumber === numPages ? numPages : pageNumber + 1)
  const prevPage = () => setPageNumber(pageNumber === 1 ? 1 : pageNumber - 1)
  const onDocumentLoadSuccess = ({numPages}) => setNumPages(numPages);


  const PageNavigator = () => 
    <div className='text-center' style={{marginBottom: 60, marginTop: 10}}>
      <Button
        className='mr-2'
        disabled={pageNumber === 1 ? true : false} 
        onClick={prevPage}
      >
        &lt;
      </Button> 
      <Button 
        className='ml-2'
        disabled={pageNumber === numPages ? true : false} 
        onClick={nextPage}
      >
        &gt;
      </Button>
      <hr />
    </div>


  return (
    <div className="pb-6">

      {
        title &&
        <h2>{title}</h2>
      }
      {
        subtitle &&
        <h4>{subtitle}</h4>
      }
      <div className="overflow-auto">
        <Document 
          file={pdfDocument} 
          onLoadSuccess={onDocumentLoadSuccess}
          error="Ошибка при загрузке файла."
          noData="Файл не найден"
          loading={()=><BarLoader />}
        >
          <Page 
            pageNumber={pageNumber}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={1000}
          />
        </Document>
      </div>
      <PageNavigator />
    </div>
  )
}
  

  
function TopRangeSafety() {

  if (typeof Promise.withResolvers === 'undefined') {
    if (window)
      window.Promise.withResolvers = function () {
        let resolve, reject;
        const promise = new Promise((res, rej) => {
          resolve = res;
          reject = rej;
        });
        return { promise, resolve, reject };
      };
  }

  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
  
  return (
    <Container >

      <div>
        <h2 style={{color: "#dc0000", marginTop: "150px"}}>Охрана труда</h2>
      </div>

      <SafetyPDF 
        title={"Специальная оценка условий труда"}
        subtitle={"Офис в Москве"}
        pdfDocument={soutMoscowPDF}
      />

      <SafetyPDF 
        subtitle={"Офис в Санкт-Петербурге"}
        pdfDocument={soutSpbPDF}
      />

      <SafetyPDF 
        subtitle={"Офис в Лахта-Центре"}
        pdfDocument={soutLakhtaPDF}
      />

      <SafetyPDF 
        subtitle={"2026"}
        pdfDocument={sout2026PDF}
      />

      <SafetyPDF 
        title={"Реестр нормативных правовых актов в области охраны труда"}
        pdfDocument={registerPDF}
      />
      
    </Container>
  )
}

export default TopRangeSafety;